import { FieldHookConfig, useField } from 'formik';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import RadioButton from '../RadioButton';
import { RadioButtonGroupProps } from './types';
import ComplexInlineHelp from '../../forms/ComplexInlineHelp';
import SummaryDisplay from '../../SummaryDisplay';

const RadioButtonGroup = <T extends {}>(props: RadioButtonGroupProps<T> & FieldHookConfig<T>) => {
    const {
        displayHorizontally,
        inlineHelp,
        inlineHelpTitle,
        options,
        name,
        legend,
        id,
        onChange,
        isSummary,
        containerClassName = '', // default props
        className = '', // default props
        subFormField,
        ...rest
    } = props;

    const helpId = inlineHelp ? `help-${id || name}` : undefined;
    const legendId = `${id || name}`;
    const [field, meta] = useField(name);

    if (isSummary) {
        if (field && field.value) {
            const currentFieldIndex = options.findIndex((x) => x.value === field.value);
            return (
                <SummaryDisplay
                    label={legend}
                    value={options[currentFieldIndex].label}
                    // descriptor={options[currentFieldIndex].descriptor}
                    id={id || name}
                    as='span'
                    containerClassName={containerClassName}
                    className={className}
                />
            );
        }

        return null;
    }

    return (
        <fieldset
            data-testid={`fs-${legendId}`}
            aria-describedby={
                meta.touched && meta.error
                    ? `${id || name}-validation-msg`
                    : (helpId || undefined)
            }
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
            role='radiogroup'
        >
            <legend id={legendId}>{legend}</legend>
            <Form.Group id={name} className={`form-field-container ${containerClassName}`} tabIndex={-1}>
                {inlineHelp && !inlineHelpTitle
          && (
              <Form.Text as='p' id={helpId} className='contextual-help'>
                  {inlineHelp}
              </Form.Text>
          )}
                {inlineHelp && inlineHelpTitle
          && (
              <ComplexInlineHelp id={helpId} title={inlineHelpTitle} inlineHelp={inlineHelp} />
          )}
                {displayHorizontally
                    ? (
                        <Row>
                            {options.map((option) => (
                                <Col key={`${option.value}`}>
                                    <RadioButton
                                        name={name}
                                        onChange={onChange}
                                        subFormField={subFormField}
                                        {...option}
                                        {...rest}
                                    />
                                </Col>
                            ))}
                        </Row>
                    )
                    : (
                        options.map((option) => (
                            <RadioButton
                                key={`${option.value}`}
                                name={name}
                                onChange={onChange}
                                subFormField={subFormField}
                                {...option}
                                {...rest}
                            />
                        ))
                    )}
                {meta.touched && meta.error
                    ? (
                        <Form.Control.Feedback type='invalid' id={`${id || name}-validation-msg`} className='form-validation-message'>
                            {meta.error}
                        </Form.Control.Feedback>
                    )
                    : null}
            </Form.Group>
        </fieldset>
    );
};

// RadioButtonGroup.defaultProps = {
//     containerClassName: '',
//     className: '',
// };

export default RadioButtonGroup;
